/**
 * A failed send never left the clinic. The thread shows the letters that
 * were received or actually sent.
 */

export function isHiddenThreadMessage(status: string): boolean {
  return status === 'failed';
}

export function visibleThreadMessages<T extends { status: string }>(messages: readonly T[]): T[] {
  return messages.filter((message) => !isHiddenThreadMessage(message.status));
}

export function visibleThreadSegments<T extends { messageHeaderId?: string; messageId?: string }>(
  segments: readonly T[],
  messages: readonly { id: string; status: string; messageHeaderId?: string | null }[],
): T[] {
  const failedIds = new Set<string>();
  const failedHeaders = new Set<string>();
  for (const message of messages) {
    if (!isHiddenThreadMessage(message.status)) continue;
    failedIds.add(message.id);
    if (message.messageHeaderId) failedHeaders.add(message.messageHeaderId);
  }
  if (failedIds.size === 0 && failedHeaders.size === 0) return [...segments];
  return segments.filter((segment) => {
    if (segment.messageId && failedIds.has(segment.messageId)) return false;
    if (segment.messageHeaderId && failedHeaders.has(segment.messageHeaderId)) return false;
    return true;
  });
}
